import { IconButton, Box } from '@chakra-ui/react';
import { useState, useRef, useEffect } from 'react';
import { MdMusicNote, MdPause } from 'react-icons/md';

interface CustomAudioPlayerProps {
  src: string;
}

const CustomAudioPlayer: React.FC<CustomAudioPlayerProps> = ({ src }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio(src);
    } else {
      audioRef.current.src = src;
    }
    const handleEnded = () => setIsPlaying(false);
    audioRef.current.addEventListener('ended', handleEnded);
    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener('ended', handleEnded);
        audioRef.current.pause();
      }
    };
  }, [src]);

  const handleTogglePlay = () => {
    if (!audioRef.current) return;
    if (!isPlaying) {
      audioRef.current.play();
      setIsPlaying(true);
    } else {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <Box
      width="150px"
      height="100px"
      backgroundColor="#f0f0f0"
      borderRadius="4px"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <IconButton
        aria-label={isPlaying ? 'Pausar áudio' : 'Tocar áudio'}
        icon={<Box as={isPlaying ? MdPause : MdMusicNote} fontSize="32px" />}
        onClick={handleTogglePlay}
        bg="transparent"
        _hover={{ bg: 'transparent' }}
        _active={{ bg: 'transparent' }}
      />
    </Box>
  );
};

export default CustomAudioPlayer;
